import { banco } from '../db/banco'
import { novoRegistroBase, agoraISO } from '../db/tipos'
import type { Empresa, RegistroBase } from '../db/tipos'
import { gravarLocalEEnfileirar } from '../sync/outbox'

// Spec 2026-10-06: a empresa e da CONTA (uma linha por tenant). Grava local +
// outbox como o resto: salva sem internet e sobe depois.
export type CamposEmpresa = Omit<Empresa, keyof RegistroBase>

export const EMPRESA_VAZIA: CamposEmpresa = {
  razao_social: null, nome_fantasia: null, cnpj: null, email: null, telefone: null,
  endereco: null, cep: null, municipio: null, uf: null, logo: null,
}

// Revisao final: o id da linha e o id do USUARIO (1 conta = 1 pessoa hoje).
// Dois aparelhos gravam a mesma linha (sem bater no unique(tenant_id) do
// servidor) e a empresa de outra conta que ficou no cache do navegador nunca
// aparece no PDF nem no circulo.
export async function buscarEmpresa(usuarioId: string | undefined): Promise<Empresa | undefined> {
  if (!usuarioId) return undefined
  const e = await banco.empresas.get(usuarioId)
  return e && e.apagado_em === null ? e : undefined
}

export async function salvarEmpresa(campos: CamposEmpresa, usuarioId: string): Promise<void> {
  const existente = await buscarEmpresa(usuarioId)
  await gravarLocalEEnfileirar('empresas', {
    ...(existente ?? { ...novoRegistroBase(), id: usuarioId }),
    ...campos,
    atualizado_em: agoraISO(),
  })
}

export function empresaPreenchida(e: Empresa | undefined): boolean {
  return !!e?.razao_social && e.razao_social.trim() !== ''
}
